import { api } from "./axios.config";
import axios from "./axios";

const API_URL = api.apiUrl;
const EVENT_URL = "/event/";
const BANK_URL = "/bank-details";

export const getEventDetails = eventId => {
	return axios.get(API_URL + EVENT_URL + eventId);
};

export const putEventDetails = (payload, eventId) => {
	return axios.put(API_URL + EVENT_URL + eventId, payload);
};

//bank details get api
export const getBankDetails = eventId => {
	return axios.get(API_URL + EVENT_URL + eventId + BANK_URL);
};

//bank details post api
export const postBankDetails = (payload, eventId) => {
	return axios.post(API_URL + EVENT_URL + eventId + BANK_URL, payload);
};

//bank details put api
export const putBankDetails = (payload, eventId) => {
	return axios.put(API_URL + EVENT_URL + eventId + BANK_URL, payload);
};

//bank details delete api
export const deleteBankDetails = eventId => {
	return axios.delete(API_URL + EVENT_URL + eventId + BANK_URL);
};
